jQuery(document).ready(function($){
  $('.eventFilter__selector').on('change', function(e){
    var selected_month = $('#event_month__selector option:selected').val();
    var selected_sessionType = $('#event_session__selector option:selected').val();
    var selected_location = $('#event_location__selector option:selected').val();

    $('.event_card').each(function(index, value){
      var event_month = $(this).data('month');
      var event_sessionType = $(this).data('sessiontype');
      var event_location = $(this).data('location');

      if( selected_month == 'all' || selected_month == event_month )
        $(this).addClass('yes_month');
      else $(this).removeClass('yes_month');

      if( selected_location == 'all' || selected_location == event_location )
        $(this).addClass('yes_location');
      else $(this).removeClass('yes_location');

      if( selected_sessionType == 'all' || event_sessionType.indexOf(selected_sessionType) > -1 )
        $(this).addClass('yes_session');
      else $(this).removeClass('yes_session');
    })

    if($('.yes_month.yes_session.yes_location').length < 1){
      $('.eventFilter__error').show();
    }
    else{
      $('.eventFilter__error').hide();
    }
  })
  $('.clearFilters').on('click', function(e){
    e.preventDefault();
    $('#event_month__selector').prop("selectedIndex", 0).change();
    $('#event_session__selector').prop("selectedIndex", 0).change();
    $('#event_location__selector').prop("selectedIndex", 0).change();
  })
})